import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useTranslation } from "react-i18next";
import { colors } from '../components/Theme/WebTheme';
import { FONT_FAMILY } from 'common/sharedFunctions';
import adminTokens from '../styles/adminDesignTokens';

export default function AlertDialog(props) {
  const { t } = useTranslation();
  const { open, onClose, children } = props;
  
  const commonStyles = {
    fontFamily: FONT_FAMILY,
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{ className: "garahex-admin-dialogPaper" }}
    >
      <DialogTitle id="alert-dialog-title" style={{ ...commonStyles, fontWeight: 900, color: adminTokens.colors.text }}>{"Alert"}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description" style={commonStyles}>
          {children}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          style={{
            backgroundColor: colors.ALERT_BUTTON_CLOSE_COLOR,
            color: colors.Black,
            padding: 10,
            fontFamily: FONT_FAMILY,
            borderRadius: 999,
            fontWeight: 800,
          }}
        >
          {t('close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
